import React, { ReactNode } from 'react';

import SpinnerWrapper from 'components/App/PartnerProvider/SpinnerWrapper';
import Spinner from 'components/Spinner';
import { StyledActions } from 'components/StyledActions';
import SuccessPageHeading from 'components/SuccessPageHeading';
import FormPageLayout from 'modules/FormPage/FormPageLayout/FormPageLayout';

import { BfsDoiResultStatus } from '../BfsDoubleOptIn.model';

type BfsDoiResultPageProps = {
  status: BfsDoiResultStatus;
  heading: string;
  subheading: string;
  /** Optional button row rendered below the heading (success/error states). */
  action?: ReactNode;
};

/**
 * Shared terminal-state renderer for the BfS DOI landing pages: a full-page
 * spinner while the request is in flight, then a centered success (green
 * checkmark) or error (red close) heading — mirroring RegistrationSuccess /
 * RegistrationLinkExpired.
 */
const BfsDoiResultPage = ({ status, heading, subheading, action }: BfsDoiResultPageProps) => {
  if (status === 'loading') {
    return (
      <SpinnerWrapper data-testid="spinner">
        <Spinner />
      </SpinnerWrapper>
    );
  }

  const isSuccess = status === 'success';

  return (
    <FormPageLayout withBadges={false}>
      <SuccessPageHeading
        success={isSuccess}
        iconType={isSuccess ? 'checkmark' : 'close'}
        heading={heading}
        subheading={subheading}
      />
      {action && <StyledActions>{action}</StyledActions>}
    </FormPageLayout>
  );
};

export default BfsDoiResultPage;
